import { FiLinkToType } from '@fi-shared/fi-text-item-helper/fi-link-to-type';
import { ObjectTypes } from '@fi-shared/types';

export interface IMediaItemLinkMenuItem {
    label: string;
    iconClass: string;
    linkToType: number;
    objectType?: number;
}

export const FiTextItemMediaPanelLinkMenuItemsInternal: IMediaItemLinkMenuItem[] = [
    {
        label: 'common.document_link',
        iconClass: 'fas fa-file',
        linkToType: FiLinkToType.Document,
        objectType: ObjectTypes.Document,
    },
    {
        label: 'common.file_link',
        iconClass: 'fas fa-file-archive',
        linkToType: FiLinkToType.Media,
        objectType: ObjectTypes.MediaBank,
    },
    {
        label: 'common.colleague_link',
        iconClass: 'fas fa-user',
        linkToType: FiLinkToType.UserProfile,
        objectType: ObjectTypes.User,
    },
    {
        label: 'common.checklist_link',
        iconClass: 'fa fa-check-square-o',
        linkToType: FiLinkToType.CheckList,
        objectType: ObjectTypes.CheckList,
    },
];

export const FiTextItemMediaPanelLinkMenuItemsExternal: IMediaItemLinkMenuItem[] = [
    {
        label: 'common.website_link',
        iconClass: 'fas fa-globe-europe',
        linkToType: FiLinkToType.WebAddress,
    },
];

export const FiTextItemMediaPanelLinkMenuItems: IMediaItemLinkMenuItem[] = [
    ...FiTextItemMediaPanelLinkMenuItemsInternal,
    ...FiTextItemMediaPanelLinkMenuItemsExternal,
];
